<template>
  <div class="pb-5">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-card v-if="sendToFactoryAvailable">
      <v-card-title>
        <h4>ارسال سفارش {{ factoryInfo.orderCode }} به کارخانه</h4>
      </v-card-title>
      <v-card-text class="py-0 px-2" v-if="sendToFactoryAvailable">
        <v-container class="mt-3 p-4">
          <v-row>
            <v-col class="text-left"
              ><v-btn class="warning mb-6" @click="autofill()">
                پر کردن خودکار فیلد‌های فرم
              </v-btn></v-col
            >
          </v-row>
          <div class="mx-auto">
            <v-row class="mb-3 mx-auto" style="width: 80%"
              ><h5 style="width: 80%">فرم ارسال به کارخانه پیشین</h5></v-row
            >
            <table
              class="orderInfoTable mx-auto"
              border="1px"
              style="width: 80%"
            >
              <tr>
                <th class="p-1">کد ردیابی</th>
                <td class="p-1">{{ previousSent.factoryCode }}</td>
              </tr>
              <tr>
                <th class="p-1">نام مشتری</th>
                <td class="p-1">{{ previousSent.customerName }}</td>
              </tr>
              <tr>
                <th class="p-1">شماره درخواست مشتری</th>
                <td class="p-1">
                  {{ previousSent.originalRequestId }}
                </td>
              </tr>
              <tr>
                <th class="p-1">تعداد اقلام سفارش</th>
                <td class="p-1">{{ previousSent.count }}</td>
              </tr>
              <tr>
                <th class="p-1">بسته‌بندی</th>
                <td class="p-1">{{ previousSent.package }}</td>
              </tr>
              <tr>
                <th class="p-1">پوشش</th>
                <td class="p-1">{{ previousSent.coating }}</td>
              </tr>
              <tr>
                <th class="p-1">زمان تحویل</th>
                <td class="p-1">
                  {{ previousSent.desiredDate }}
                </td>
              </tr>
              <tr>
                <th class="p-1">محل تحویل</th>
                <td class="p-1">
                  {{ previousSent.deliveryLocation }}
                </td>
              </tr>
              <tr>
                <th class="p-1">هزینه حمل</th>
                <td class="p-1">
                  {{ previousSent.transportCost }}
                </td>
              </tr>
              <tr>
                <th class="p-1">نام نماینده مشتری</th>
                <td class="p-1">
                  {{ previousSent.customerAgentName }}
                </td>
              </tr>
              <tr>
                <th class="p-1">بازرسی</th>
                <td class="p-1">
                  {{ previousSent.inspection }}
                </td>
              </tr>
              <tr>
                <th class="p-1">وزن</th>
                <td class="p-1">{{ previousSent.weight }}</td>
              </tr>
              <tr>
                <th class="p-1">شماره تماس مشتری</th>
                <td class="p-1">{{ previousSent.phone }}</td>
              </tr>
              <tr>
                <th class="p-1">سایر توضیحات</th>
                <td class="p-1">
                  {{ previousSent.otherDescriptions }}
                </td>
              </tr>
              <tr>
                <th class="p-1">آدرس تحویل</th>
                <td class="p-1">
                  {{ previousSent.deliveryAddress }}
                </td>
              </tr>
            </table>
          </div>

          <p class="mt-3">
            لطفا به منظور ارسال سفارش به کارخانه، موارد زیر را پر کنید:
          </p>
          <b-form-group label="تاریخ و ساعت ابلاغ">
            <date-picker
              placeholder="تاریخ"
              v-model="factoryInfo.registerDate"
              :editable="true"
            ></date-picker>
            <date-picker
              placeholder="ساعت"
              v-model="factoryInfo.registerTime"
              :editable="true"
              type="time"
            ></date-picker>
          </b-form-group>
          <v-text-field
            outlined
            dense
            label="نام مشتری"
            v-model="factoryInfo.customerName"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            disabled
            filled
            label="شماره سفارش"
            v-model="factoryInfo.orderCode"
          ></v-text-field>
          <v-select
            outlined
            dense
            label="اولویت سفارش و اقلام سفارش"
            :items="priorityOptions"
            v-model="factoryInfo.priority"
          ></v-select>
          <v-text-field
            outlined
            dense
            label="تعداد اقلام"
            v-model="factoryInfo.count"
            type="number"
          ></v-text-field>
          <v-select
            outlined
            dense
            label="نوع بسته بندی"
            :items="packageOptions"
            v-model="factoryInfo.package"
          ></v-select>
          <v-text-field
            outlined
            dense
            label="نوع پوشش"
            v-model="factoryInfo.coating"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="زمان تحویل"
            v-model="factoryInfo.desiredDate"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="محل تحویل"
            v-model="factoryInfo.deliveryLocation"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            v-model="factoryInfo.transportCost"
            label="هزینه حمل"
          />
          <v-select
            outlined
            dense
            label="جنسیت (نماینده مشتری)"
            :items="genderItems"
            v-model="genderCustomerAgentName"
          ></v-select>
          <v-text-field
            outlined
            dense
            :prefix="genderCustomerAgentName"
            label="نام نماینده مشتری"
            v-model="factoryInfo.customerAgentName"
          ></v-text-field>
          <v-select
            outlined
            dense
            label="بازرسی"
            :items="inspectionOptions"
            v-model="factoryInfo.inspection"
          ></v-select>
          <v-text-field
            outlined
            dense
            label="کیلویی"
            v-model="factoryInfo.weight"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="شماره تماس مشتری"
            v-model="factoryInfo.phone"
          ></v-text-field>
          <v-textarea
            outlined
            dense
            label="سایر توضیحات"
            v-model="factoryInfo.otherDescriptions"
          ></v-textarea>
          <v-text-field
            outlined
            dense
            label="آدرس ارسال"
            v-model="factoryInfo.deliveryAddress"
          ></v-text-field>
          <p>یادداشت</p>
          <div class="mb-5 item-ckeditor">
            <ckeditor
              v-model="note"
             :editor="editor"
                  :config="editorConfig"
              @blur="onBlur($event)"
              @focus="onFocus($event)"
              @contentDom="onContentDom($event)"
              @dialogDefinition="onDialogDefinition($event)"
              @fileUploadRequest="onFileUploadRequest($event)"
              @fileUploadResponse="onFileUploadResponse($event)"
            />
          </div>
          <b-table
            responsive
            :items="factoryInfo.files"
            :fields="fileFields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            show-empty
            striped
            :busy="isBusy"
          >
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + +1 }}
              </div>
            </template>
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(send)="data">
              <b-form-checkbox v-model="data.item.send"></b-form-checkbox>
            </template>

            <template v-slot:cell(download)="data">
              <div style="text-align: center; vertical-align: middle">
                <!-- <b-button variant="success" @click="downloadFile(data.download)"><i
                        class="fa fa-download"
                        aria-hidden="true"
                ></i></b-button>-->
                <a
                  class="btn btn-success"
                  :href="data.item.url"
                  role="button"
                  target="_blank"
                >
                  <i class="fa fa-download" aria-hidden="true"></i>
                </a>
                &nbsp;
                <!-- <b-btn v-if="role=='Manager'" variant="danger" @click="delFile(data.item)">
                  <i class="fa fa-remove" aria-hidden="true"></i>
                </b-btn>-->
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-form-group label="بارگذاری فایل:" label-for="indexPic">
            <b-form-file
              id="indexPic"
              :state="Boolean(uploadedFiles.length)"
              @input="upload(file)"
              v-model="file"
              browse-text="آپلود"
              placeholder="فایل مربوطه را آپلود کنید"
              accept="*"
            ></b-form-file>
          </b-form-group>
          <b-form-group>
            <v-col>
              <br />
              <b-progress
                v-if="myFile.showProgress"
                :value="myFile.uploadPercentage"
                :max="max"
                show-progress
                :animated="myFile.striped"
                :variant="myFile.variant"
              ></b-progress>
              <br />
              <br />
              <v-row>
                <div v-if="myFile.isUploaded" color="green">
                  فایل با موفقیت آپلود شد.
                </div>
              </v-row>
            </v-col>
          </b-form-group>
        </v-container>
      </v-card-text>

      <v-card-actions class="p-3 mr-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="sendToFactory()"> ارسال </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title>
        <h4>{{ errorMessage }}</h4>
      </v-card-title>
    </v-card>
    <v-dialog v-model="openDialog" width="700">
      <v-card>
        <v-card-title>پر کردن خودکار فیلدها</v-card-title>
        <v-card-text class="mt-6">
          <v-row>
            <h5>
              در صورت انتخاب این گزینه، فیلدهای فرم ارسال به کارخانه مطابق فرم
              قبلی به صورت خودکار پر خواهد شد. آیا مطمئن هستید؟
            </h5>
          </v-row>
          <div class="text-left">
            <v-btn class="red text-white mt-3 me-3" @click="doFill()">
              بله
            </v-btn>
            <v-btn class="primary text-white mt-3" @click="openDialog = false">
              خیر
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import router from "../router";
import moment from "moment-jalaali";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    CKEditor,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      guide: false,
      isBusy: false,
      openDialog: false,
      valueWhenIsEmpty: "",
      options: {
        decimal: ",",
        thousands: ",",
        precision: 0,
        length: 16,
      },
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      factoryInfo: {},
      previousSent: {},
      priorityOptions: [
        {
          value: "low",
          text: "پایین",
        },
        {
          value: "normal",
          text: "معمولی",
        },
        {
          value: "high",
          text: "بالا",
        },
        {
          value: "urgent",
          text: "اورژانسی",
        },
      ],
      note: "",
      fileFields: [
        { key: "send", label: "ارسال شود" },
        { key: "index", label: "#" },
        // { key: "uploadDate", label: "تاریخ آپلود" },
        { key: "showName", label: "نام فایل" },
        // { key: "subject", label: "توضیحات" },
        { key: "uploaderName", label: "فرد بارگذاری کننده" },
        { key: "download", label: "دریافت" },
      ],
      packageOptions: [
        {
          value: "کارتن یا پالت چوبی",
          text: "کارتن یا پالت چوبی",
        },
        {
          value: "پالت فلزی",
          text: "پالت فلزی",
        },
        {
          value: "صندوق چوبی",
          text: "صندوق چوبی",
        },
        {
          value: "سایر",
          text: "سایر",
        },
      ],
      inspectionOptions: [
        {
          value: "دارد",
          text: "دارد",
        },
        {
          value: "ندارد",
          text: "ندارد",
        },
      ],
      genderCustomerAgentName: '',
      genderItems: [
        {text: 'آقا', value: 'آقا‌ی'},
        {text: 'خانم', value: 'خانم'},
        {text: 'تمایلی به بیان ندارم', value: ''},
      ],
      sendToFactoryAvailable: false,
      errorMessage: "",
    };
  },
  computed: {
    approvedFiles() {
      let myFiles = [];
      myFiles = this.factoryInfo.files.filter((x) => x.send);
      return myFiles;
    },
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    checkProductionItems() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/checkProductionItems",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.sendToFactoryAvailable = res.data;
            this.showConfirmedOrders();
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.errorMessage = err.response.data;
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    previousOrder() {
      Axios.post(
        this.baseUrl + "/ppkpms/office/order/sendToFactoryInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.previousSent = res.data;
          } else {
            this.toast(".ارسال شناسه سفارش الزامی است", "error");
          }
        })
        .catch((err) => {
          this.errorMessage = err.response.data;
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    showConfirmedOrders() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/getInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.factoryInfo = res.data;

            this.factoryInfo.registerDate = moment(new Date()).format(
              "jYYYY/jMM/jDD"
            );
            this.factoryInfo.registerTime = moment(new Date()).format("HH:mm");

            // EXTRACT Items
            let myAnalyzedItems;
            try {
              myAnalyzedItems = JSON.parse(this.factoryInfo.tempOrderItems);
            } catch (error) {
              myAnalyzedItems = [];
            }

            let myItems;
            try {
              myItems = JSON.parse(this.factoryInfo.orderItems);
            } catch (error) {
              myItems = [];
            }

            // Priority
            try {
              if (this.factoryInfo.customer_priority == "VIP")
                this.factoryInfo.priority = "high";
              else if (this.factoryInfo.customer_priority == "لیست سیاه")
                this.factoryInfo.priority = "low";
              else this.factoryInfo.priority = "normal";
            } catch (error) {
              this.factoryInfo.priority = "normal";
            }

            // Calculate Count
            try {
              this.factoryInfo.count = myItems.length;
            } catch (error) {
              this.factoryInfo.count = 0;
            }

            // Packaging
            this.factoryInfo.package = "کارتن یا پالت چوبی";

            // Calculate Coating
            try {
              let coatings = [...new Set(myAnalyzedItems.map((x) => x.cover))];
              if (coatings.length == 1) this.factoryInfo.coating = coatings[0];
              else this.factoryInfo.coating = "مطابق پیش فاکتور";
            } catch (error) {
              this.factoryInfo.coating = "مطابق پیش فاکتور";
            }

            // Delivery Date
            this.factoryInfo.desiredDate =
              "3 هفته کاری پس از دریافت پیش‌پرداخت";

            // Delivery Location
            this.factoryInfo.deliveryLocation = "درب کارخانه پولاد پیچکار";

            // Transport Cost
            this.factoryInfo.transportCost = "به عهده خریدار";

            // Customer Name
            this.factoryInfo.customerAgentName = this.factoryInfo.contactName;

            // Inspection
            this.factoryInfo.inspection = "دارد";

            // Files
            try {
              this.factoryInfo.files = JSON.parse(this.factoryInfo.files);
            } catch (error) {
              this.factoryInfo.files = [];
            }
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.Busy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    autofill() {
      this.openDialog = true;
    },
    doFill() {
      this.factoryInfo.customerName = this.previousSent.customerName;
      this.factoryInfo.priority = this.previousSent.priority;
      this.factoryInfo.count = this.previousSent.count;
      this.factoryInfo.package = this.previousSent.package;
      this.factoryInfo.coating = this.previousSent.coating;
      this.factoryInfo.desiredDate = this.previousSent.desiredDate;
      this.factoryInfo.deliveryLocation = this.previousSent.deliveryLocation;
      this.factoryInfo.transportCost = this.previousSent.transportCost;
      this.factoryInfo.customerAgentName = this.previousSent.customerAgentName;
      this.factoryInfo.inspection = this.previousSent.inspection;
      this.factoryInfo.phone = this.previousSent.phone;
      this.factoryInfo.otherDescriptions = this.previousSent.otherDescriptions;
      this.factoryInfo.deliveryAddress = this.previousSent.deliveryAddress;

      let previousFiles = JSON.parse(this.previousSent.factoryFiles)
      console.log(previousFiles)


      this.factoryInfo.files.forEach((file) => {
        console.log(file)
        if (
          previousFiles.filter(
            (x) => x.name == file.name
          ).length
        )
          file.send = true;
      });

      this.openDialog = false;
    },
    upload(file) {
      if (!file) {
        return;
      }
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      Axios.post(this.baseUrl + "/ppkpms/uploads/private", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myFile.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1;
        }).bind(this),
      })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.uploadedFiles = d.data;
            Axios.post(
              this.baseUrl + "/ppkpms/order/attachFile",
              {
                orderId: this.$route.params.id,
                file: JSON.stringify(d.data[0]),
              },
              {
                headers: {
                  Authorization: "Bearer: " + localStorage.getItem("token"),
                },
              }
            )
              .then((res) => {
                if (res.status == 200) {
                  this.isBusy = true;
                  setTimeout(() => {
                    this.factoryInfo.files = res.data;
                    this.isBusy = false;
                  }, 500);
                } else {
                  const title = (
                    <div>
                      <h5>خطا </h5>
                      <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
                    </div>
                  );
                  this.toast(title, "error");
                }
              })
              .catch((err) => {
                this.toast(err.response.data, "error");
              });
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    sendToFactory() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/sendToFactory",
        {
          orderId: this.$route.params.id,
          priority: this.factoryInfo.priority,
          factoryFiles: JSON.stringify(this.approvedFiles),
          factoryCoating: this.factoryInfo.coating,
          factoryCount: this.factoryInfo.count,
          factoryCustomerAgentName: this.genderCustomerAgentName ? this.genderCustomerAgentName + " " + this.factoryInfo.customerAgentName : this.factoryInfo.customerAgentName,
          factoryDate:
            this.factoryInfo.registerDate + " " + this.factoryInfo.registerTime,
          factoryDeliveryAddress: this.factoryInfo.deliveryAddress,
          factoryDeliveryCost: this.factoryInfo.transportCost,
          factoryDeliveryDuration: this.factoryInfo.desiredDate,
          factoryDeliveryLocation: this.factoryInfo.deliveryLocation,
          factoryInspection: this.factoryInfo.inspection,
          factoryOtherDescriptions: this.factoryInfo.otherDescriptions,
          factoryPackage: this.factoryInfo.package,
          factoryPhone: this.factoryInfo.phone,
          factoryWeight: this.factoryInfo.weight,
          note: this.note,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.$router.push("/factory/order/" + this.$route.params.id);
            this.toast(res.data, "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
  },
  mounted() {
    this.checkProductionItems();
    this.previousOrder();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.orderInfoTable {
  border-radius: unset;
}
.orderInfoTable tr:nth-child(odd) {
  background-color: #d0d3d6;
}
</style>
